import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Support } from '@/modules/support/support.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createSupport = () => ({
  body: generateJoiValidation(Support.schema),
});

export const updateSupport = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Support.schema, true),
});

export const getSupport = {
  query: Joi.object().keys({
    name: Joi.string(),
    role: Joi.string(),
    sortBy: Joi.string(),
    projectBy: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    search: Joi.string(),
    fields: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    companyId: Joi.string(),
  }),
};

export const getSupportById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteSupportById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
